var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"h-[100vh] w-[100vw] flex justify-center items-center"},[_c('loading-section')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }